var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPolygons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35545 13.1248C9.35545 12.2964 10.027 11.6248 10.8555 11.6248H15.9961C16.8245 11.6248 17.4961 12.2964 17.4961 13.1248V16C17.4961 16.8284 16.8245 17.5 15.9961 17.5H10.8555C10.027 17.5 9.35545 16.8284 9.35545 16V13.1248ZM2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H9.1406C9.96903 2.5 10.6406 3.17157 10.6406 4V7.99803C10.6406 8.82646 9.96903 9.49803 9.14061 9.49803H4C3.17157 9.49803 2.5 8.82646 2.5 7.99803V4ZM12.7832 6.26545C12.7832 5.43703 13.4548 4.76545 14.2832 4.76545H15.9961C16.8245 4.76545 17.4961 5.43703 17.4961 6.26545V7.97833C17.4961 8.80676 16.8245 9.47833 15.9961 9.47833H14.2832C13.4548 9.47833 12.7832 8.80676 12.7832 7.97833V6.26545ZM2.5 13.1248C2.5 12.2964 3.17157 11.6248 4 11.6248H5.71288C6.54131 11.6248 7.21288 12.2964 7.21288 13.1248V14.8377C7.21288 15.6662 6.54131 16.3377 5.71288 16.3377H4C3.17157 16.3377 2.5 15.6662 2.5 14.8377V13.1248Z",
    stroke: "#6E7882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolygons);
export default __webpack_public_path__ + "static/media/icon-polygons.2ca264ef03c36a3cc3196aa93f52226f.svg";
export { ForwardRef as ReactComponent };